module.exports = __webpack_public_path__ + "static/img/bgc_03.1c2eddd.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/mobile/bgc_03.png
// module id = v6yf
// module chunks = 6